import { Link } from 'react-router-dom';
import Icon from '@components/common/Icon';
import ImageCard from '@components/common/ImageCard';
import { DATA_BASE_URL } from '@lib/constants';

const passions = [
  {
    to: '/music',
    icon: 'music',
    image: `${DATA_BASE_URL}/data/awards/photos/mathematics_honors_society_2025.webp`,
    title: 'Music',
    description: 'Accomplished musician with certifications and performance experience. Music enriches my creative and analytical thinking.',
    cta: 'Explore'
  }
];

const PassionsSection = () => {
  return (
    <section className="py-16 sm:py-20 px-4 md:px-4">
      <div className="container mx-auto max-w-7xl">
        <h2
          className="text-3xl sm:text-4xl font-heading font-bold text-center mb-8 sm:mb-12 tracking-tight"
          style={{ color: 'var(--color-heading)' }}
        >
          Other Interest
        </h2>
        {/* Single centered card */}
        <div className="flex justify-center max-w-md mx-auto">
          {passions.map((passion, index) => (
            <Link key={index} to={passion.to} className="group h-full w-full">
              <div
                className="h-full flex flex-col rounded-xl border transition-all duration-200 hover:shadow-card-hover shadow-card overflow-hidden"
                style={{
                  backgroundColor: 'var(--color-card-bg)',
                  borderColor: 'var(--color-card-border)'
                }}
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <ImageCard
                    src={passion.image}
                    alt={passion.title}
                    aspectRatio="aspect-video"
                    rounded={false}
                    shadow={false}
                    className="h-full"
                  />
                </div>

                {/* Content */}
                <div className="flex-1 flex flex-col p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div
                      className="w-14 h-14 rounded-lg flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: 'var(--color-theme-2)' }}
                    >
                      <Icon name={passion.icon} size="lg" style={{ color: 'var(--color-icon-default)' }} />
                    </div>
                    <h3
                      className="text-xl font-bold"
                      style={{ color: 'var(--color-heading)' }}
                    >
                      {passion.title}
                    </h3>
                  </div>
                  <p
                    className="leading-relaxed text-base mb-6 flex-1"
                    style={{ color: 'var(--color-card-text)' }}
                  >
                    {passion.description}
                  </p>
                  <div
                    className="font-medium group-hover:translate-x-1 transition-transform inline-flex items-center gap-1"
                    style={{ color: 'var(--color-link)' }}
                  >
                    {passion.cta} →
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PassionsSection;
